export const EMPOWERLY_COURSES = [
  'ai_machine_learning_deep_dive',
  'ai_machine_learning_deep_dive_hs',
  'accelerated_computer_science_college_prep',
  'accelerated_computer_science_college_prep_hs',
];
